import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ResourcesBasicInfoComponent = ({
    selectResources, handleInnerFormChange, resource, resourceAccessLevel, accountTypesListLoading, accountListLoading, accountsList, accountTypesList, policyOwnerType
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Level"
                            labelField="Text"
                            list={policyOwnerType}
                            isDisabled={selectResources?.Id && selectResources?.OwnerLevelId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerLevelId'
                                );
                            }}
                            optionName='Choose Level'
                            type="select"
                            value={selectResources?.OwnerLevelId}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Account Type"
                            labelField="Name"
                            isLoading={accountTypesListLoading}
                            list={accountTypesList}
                            isDisabled={selectResources?.Id && selectResources?.OwnerTypeId}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerTypeId',
                                );
                            }}
                            optionName='Choose Account Type'
                            type="select"
                            value={selectResources?.OwnerTypeId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Account Name"
                            labelField="Name"
                            isLoading={accountListLoading}
                            list={accountsList}
                            isDisabled={selectResources?.Id && selectResources?.OwnerAccountId}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerAccountId',
                                );
                            }}
                            optionName='Choose Account Name'
                            type="select"
                            value={selectResources?.OwnerAccountId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Name"
                            labelField="Name"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                );
                            }}
                            type="text"
                            value={selectResources?.Name}
                        />

                        <InputContainer
                            label="Description"
                            labelField="Description"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Description'
                                );
                            }}
                            type="text"
                            value={selectResources?.Description}
                        />


                        <InputContainer
                            label="Url"
                            labelField="Url"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Url'
                                );
                            }}
                            type="text"
                            value={selectResources?.Url}
                        />

                        <InputContainer
                            label="Resource Type"
                            labelField="Text"
                            list={resource}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ResourceType',
                                );
                            }}
                            optionName='Choose Entity Type'
                            type="select"
                            value={selectResources?.ResourceType}
                            valueField="Text"
                        />
                        <InputContainer
                            label="Resource Access Level"
                            labelField="Text"
                            list={resourceAccessLevel}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ResourceAccessLevel',
                                );
                            }}
                            optionName='Choose Entity Type'
                            type="select"
                            value={selectResources?.ResourceAccessLevel}
                            valueField="Text"
                        />

                        <InputContainer

                            label="Approved"
                            name="IsApproved"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'IsApproved'
                                )
                            }}
                            type="checkbox"
                            value={selectResources?.IsApproved}
                        />
                        
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    );
}

export default ResourcesBasicInfoComponent;
